// extracted by mini-css-extract-plugin
export default {"title":"app-title_title__I01a5","arrowContainer":"app-title_arrowContainer__SvmHp","arrowIcon":"app-title_arrowIcon__hvOgG"};